const APP_CONFIG = {
  version: "7.82.0",
  title: "Claire V7.82.0",
  version_client: "7.82.0",
};

export default APP_CONFIG;
